import type { HttpAdapter } from "../../core/adapters/axios.adapter";
import { type TokenDO } from "../../tokenData/models/tokenDO.models";

export class AssetScreenerService {
    constructor(private httpAdapter: HttpAdapter) { }

    async getTokenData(tokenSlug: string): Promise<TokenDO[]> {
        try {
            const queryParams = new URLSearchParams()
            queryParams.set('slugs', tokenSlug);
            // const response = await this.httpAdapter.query(`screener/fromSlugs?${queryParams.toString()}`, { method: 'GET' });
            const url = `screener/fromSlugs?${queryParams.toString()}`;
            const response = await this.httpAdapter.get<TokenDO[]>(url);
            if (response.status < 200 || response.status > 300) { throw new Error('Failed to fetch token data') }
            return response.data;
        } catch (error) {
            console.error(error)
            return []
        }
    }

}
